import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import VideoModule from 'components/VideoModule'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  return (
    <AppContainer

    >
        <VideoModule
          src={properties?.videoURL || ''}
          legend={properties?.videoLegend || ''}
        />
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  -webkit-font-smoothing: antialiased;
  font-size: 1.8rem;
  line-height: 3rem;
  margin: 2em 0 2em 0;
`
export default MainComponent
